<!--
Notification component
Usage: <NotifItem title="text" body="text" icon="fa-name" link="url" />
@author ab557z
-->
<template>
<div>

  <div style="border:0px;" class="eventDiv eventBox">

    <span class="eventHeader0">
      <span class="eventHeaderL"><img src="@/assets/event_img.svg" class="eventIcon1" /></span>
      <span class="eventHeaderN">{{ title }}</span>
    </span>

    <p class="eventBodyExp">{{ eventDate }}</p>
    <p v-if="!isEmpty(eventTime)" class="eventBodyExp">{{ eventTime }}</p>
    <p v-if="capacity" class="eventCapacityExp">Capacity: {{ capacity }} </p>
    <p v-if="basis" class="eventBasisExp">{{ basis }}</p>
    <div class="eventLocationLine"><img src="@/assets/index/location_details_solid.svg" class="eventLocIcon" /><p class="eventLocation">{{ loc }}</p></div>
    <span class="eventCategories">{{ allCategories }}</span>

    <p v-if="description" class="eventInfoExp">{{ description }}</p>

    <button v-if="findMore" @click="goExt(findMore)" class="eventFindBtn">Find out more</button>
    <span v-if="twitter || facebook || instagram" style="font-size:16px;color:#003865;">Or view on social media</span>
    <span class="eventSocial" v-if="twitter || facebook || instagram || email">
      <img v-if="twitter" @click="goExt(twitter)" src="@/assets/social/twitter.svg" />
      <img v-if="facebook" @click="goExt(facebook)" src="@/assets/social/facebook.svg" />
      <img v-if="instagram" @click="goExt(instagram)" src="@/assets/social/instagram.svg" />
      <a v-if="email" style="margin-left:10px;margin-bottom:4px;" class="purpleLink"  :href="'mailto:' + email">{{ email }}</a>
    </span>

  </div>
</div>

</template>

<script setup>
//Utilities
import {ref, onMounted, computed} from 'vue'
import axios from 'axios'

//Composables
import {useStringUtil} from '@/composables/StringMethods.js'
const {displayEventInfo, isEmpty} = useStringUtil()

const props = defineProps({
  id: Number,
  title: String,
  body: String,
  email: String,
  startDate: Number,
  endDate: Number,
  startTime: String,
  endTime: Number,
  loc: String,
  capacity: Number,
  basis: String,
  description: String,
  categories: Array
})

//Computed
const allCategories = computed(() => {
  const cats = props.categories
  return cats.map((c) => { return c.name }).join(', ')
})

//Data
const evinfo = displayEventInfo(props.startDate, props.endDate, props.startTime, props.endTime)
const eventDate = ref(evinfo.date)
const eventTime = ref(evinfo.time)
const findMore = ref(false)
const instagram = ref(false)
const facebook = ref(false)
const twitter = ref(false)
const eventLinks = ref(null);

onMounted(() => {
  let url = '/timetable/events/' + props.id + '/links'
  axios.get(url)
    .then(response => {
      eventLinks.value = response.data
      findLinks()
    })
})

function goExt (link) {
  window.open(link, '_blank').focus()
}

function findLinks () {
  for (const l of eventLinks.value) {
    switch (l.linkType) {
      case 'web':
        findMore.value = l.linkUrl
        break
      case 'twitter':
        twitter.value = l.linkUrl
        break
      case 'facebook':
        facebook.value = l.linkUrl
        break
      case 'instagram':
        instagram.value = l.linkUrl
        break
    }
  }
}

function prettyDate (date) {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
  var dateReady = new Date(date)
  return dateReady.toLocaleDateString('en-GB', options)
}

</script>

<style scoped>
.eventLocIcon {
  margin-right:6px;
  margin-left:0px;
  display:inline-block;
  margin-top:0px;
}

.eventBox {
border: 1px solid #e4e4e4;
box-sizing: border-box;
border-radius: 24px;
}

.eventDiv {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom:12px;
  padding-bottom:0px;
  padding-top:8px;
  position:relative;
}
.eventLocationLine {
  align-items: center;
}
.eventLocation {
  display:inline-block;
  font-weight:400;
  font-size:12px;
  margin-bottom:8px;
}
.eventCategories {
  margin-top:-4px;
  font-size:12px;
  color:#951272;
  display:block;
  margin-bottom:16px;
}
.eventHeader0 {
  align-items: normal;
  display: flex;
  margin-bottom: 20px;
}
.eventHeaderL {
  margin-right: 12px;
}
.eventHeaderL img {
  width: 48px;
}
.eventHeaderN {
  margin-top:16px;
  font-size: 18px;
  font-weight: 700;
}
.eventIcon1 {
  display: inline-block;
  z-index:-1;
}

.eventFindBtn {
  background-color:#003865;
  width:100%;
  color:#ffffff;
  font-family:PTSans;
  border: 1px solid #003865;
  border-radius:12px;
  height:52px;
  font-size: 18px;
  margin-bottom:21px;
  font-weight:700;
}

.eventBodyExp {
  font-size: 18px;
  margin-bottom:0px;
  color: #4F5961;
  padding-left:0px;
  padding-right:8%;
  display:block;
}

.eventBasisExp {
  font-size: 16px;
  color: #0A3875;

  padding-right:8%;
  font-weight:400;
  margin-top:0px;
  margin-bottom:16px;
}

.eventCapacityExp {
  margin-top:0px;
  margin-bottom:0px;
  margin-left:0px;
  color: #828282;
}
.eventInfoExp {

  color: #757575;
}

.eventSocial {
  display:inline;
  float: right;
  padding-left:48px;
  padding-bottom:20px;
}

.eventSocial img {
  margin-right:8px;
  margin-left:15px;
  width: 24px;
  fill:#003865;
}

.notificationIcon {
  z-index:999;
  position:absolute;
  color:#ffffff;
}

.notifBox {
border: 1px solid #DADADA;
box-sizing: border-box;
border-radius: 8px;
}

.notifDiv {
  margin-bottom:12px;
  padding:16px;
  padding-bottom:0px;
  padding-top:8px;
  position:relative;
}

.notifBg {
  position:absolute;
  left:10px;
  top:10px;
  z-index:-1;
}

.eventBody {
  font-size: 16px;
  color: #0A3875;
  padding-left:48px;
  padding-right:8%;
  display:inline-block;
  margin-bottom:0px;
}

.eventHeader {
  font-style: normal;
  display:inline-block;
  padding-left:48px;
  font-weight: bold;
  font-size: 16px;
  line-height:21px;
  color: #0A3875;
}
</style>
